import * as React from 'react'

export const SvgAddressOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" aria-hidden={true} {...props}>
    <path d="M12 3c3.314 0 6 2.637 6 5.89 0 2.732-1.536 5.623-4.608 10.11A232.56 232.56 0 0112 21c-.639-.91-1.103-1.576-1.392-1.999C7.536 14.513 6 11.621 6 8.891 6 5.637 8.686 3 12 3zm0 2C9.826 5 8.056 6.738 8.056 8.89c0 1.953.995 4.16 3.944 8.53 2.95-4.372 3.944-6.576 3.944-8.53C15.944 6.739 14.174 5 12 5zm0 2a2 2 0 110 4 2 2 0 010-4z" />
  </svg>
)
export default SvgAddressOutline
